import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=8f710d0c"
import script from "./addTask.vue?vue&type=script&lang=js"
export * from "./addTask.vue?vue&type=script&lang=js"
import style0 from "./addTask.vue?vue&type=style&index=0&id=8f710d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports